var distance = function distance(a, b) {
  return Math.abs(a - b);
};
function distance2D(a, b) {
  // Multi-dimensional
  var xDelta = distance(a.x, b.x);
  var yDelta = distance(a.y, b.y);
  return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}
export { distance, distance2D };